/* eslint-disable
    goodeggs/lodash-prefer-is-nil,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'lodash';

export default ngInject(function(
  $rootScope,
  employeeRoles,
  settings,
  $stateParams,
  Supplier,
  Catalog,
  externalUrls,
) {
  this.externalUrls = externalUrls;
  this.loading = true;
  this.supplierSlug = $stateParams.supplierSlug;

  Supplier.getBySlug($stateParams.supplierSlug)
    .then((supplier) => {
      this.supplier = supplier;
      this.catalogProducts = Catalog.query({'vendor._id': this.supplier.id});
      return this.catalogProducts.$promise;
    })
    .finally(() => (this.loading = false));

  this.orderedMarketProducts = function(catalogProduct) {
    const marketProducts = _.sortBy(catalogProduct.marketProducts, ['name', 'unitLabel']);
    for (let index = 0; index < marketProducts.length; index++) {
      const marketProduct = marketProducts[index];
      const oldName = __guard__(catalogProduct.marketProducts[index - 1], (x) => x.name);
      marketProduct.nameIsSame = oldName === marketProduct.name;
    }
    return marketProducts;
  };

  this.formatName = (catalogItem) => {
    if (catalogItem.sku != null) {
      return `(${catalogItem.sku}) ${catalogItem.name}`;
    }
    return catalogItem.name;
  };

  this.isEditable = () => {
    if (this.supplier == null) {
      return false;
    }
    return employeeRoles.can($rootScope.credentials.google.employee.roles, 'catalog.edit');
  };

  return this;
}); // http://stackoverflow.com/questions/28953289/using-controller-as-with-the-ui-router-isnt-working-as-expected

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
